import create from 'zustand';
import {convertOrderResponseToOrder} from '../helpers/converters/convertOrderResponseToOrder';
import {GetOrderResponse} from '../types/orderResponse';
import {api, apiUrlBuilder} from '../utils/api';
import {Order} from '../models/order';
import {AuthErrorTypeEnum} from './authStore';
import AbortAddon from 'wretch/addons/abort';
import {AuthError} from '../errors/authError';

export interface OrderItem {
    id: string;
    sku: string;
    name: string;
    qty: number;
    qtyRefunded: number;
}

export interface OrderStore {
    order: Order | null;
    fetchOrder: (
        bearer: string,
        abortController?: AbortController
    ) => Promise<void>;
}

export const useOrderStore = create<OrderStore>()((set, get) => ({
    order: null,
    fetchOrder: async (bearer: string, abortController?: AbortController) => {
        const response = (await api
            .url(apiUrlBuilder('/zo-geregeld/order'))
            .addon(AbortAddon())
            .signal(abortController ?? new AbortController())
            .headers({
                Authorization: `Bearer ${bearer}`,
            })
            .get()
            .unauthorized(() => {
                throw new AuthError(AuthErrorTypeEnum.NotFound);
            })
            .notFound(() => {
                throw new AuthError(AuthErrorTypeEnum.NotFound);
            })
            .badRequest(res => {
                throw new AuthError(AuthErrorTypeEnum.InputError);
            })
            .internalError(res => {
                throw new AuthError(AuthErrorTypeEnum.Error);
            })
            .json(data => {
                return data as GetOrderResponse;
            })) as GetOrderResponse;

        set({
            order: convertOrderResponseToOrder(response),
        });
    },
}));
